import React, { useContext } from 'react';

import { makeStyles, withStyles } from '@material-ui/styles';
import { TableCell, TableRow } from '@material-ui/core';

import { AppStorage } from '../../../../Core/Service/storage-service';
import { BranchFranchiseCompareContext } from './branchServicesProvider';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Label } from 'recharts';

const useStyles = makeStyles({
    mainClass: {
        background: (props) => props.headerBgColor,
        color: (props) => props.headerTextColor
    }
});

const StyledTableCell = withStyles((theme) => ({
    head: {
        fontSize: 12,
        padding: '4px',
        fontWeight: 700,
        border: '1px solid rgba(0, 0, 0, 0.12)',
        textTransform: 'uppercase'
    },
    body: {
        fontSize: 12,
        padding: '4px',
        // border: 'none',
        border: '1px solid rgba(0, 0, 0, 0.09)'
        // border: '1px solid #ccc'
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: '#F5F5F5'
        }
    }
}))(TableRow);

const DashboardHeaderRow = ({ config }) => {
    const classes = useStyles(config);
    const { handleCollaps, Collapse } = useContext(BranchFranchiseCompareContext);
    const portalSettings = AppStorage.getPortalSetting();
    const { categoryName, actualName, budgetName, varianceName, kpIsName, actualPYName, varLYName } = config;

    let actualAlign = 'left'; //portalSettings.portalSettingMADashboardActualAlign;
    let budgetAlign = 'left'; //portalSettings.portalSettingMADashboardBudgetAlign;
    let varianceAlign = 'left'; //portalSettings.portalSettingMADashboardVarianceAlign;
    let kpiAlign = 'left'; //portalSettings.portalSettingMADashboardKPIsAlign;
    let actualPYAlign = 'left'; //portalSettings.portalSettingMADashboardActualPYAlign;
    let varLYAlign = 'left'; //portalSettings.portalSettingMADashboardVarPYAlign;

    return (
        <TableRow>
            <StyledTableCell className={classes.mainClass} align="left">
                <span style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'space-between' }}>
                    <span>
                        <b>{categoryName}</b>
                    </span>
                    {config.calculated !== 2 && (
                        <span>
                            {!Collapse[config.categoryId] ? (
                                <abbr title="Collapse">
                                    <ExpandLessIcon style={{ fontSize: 18, cursor: 'pointer' }} onClick={() => handleCollaps(config.categoryId)} />
                                </abbr>
                            ) : (
                                <abbr title="Expand">
                                    <ExpandMoreIcon style={{ fontSize: 18, cursor: 'pointer' }} onClick={() => handleCollaps(config.categoryId)} />
                                </abbr>
                            )}
                        </span>
                    )}
                </span>
            </StyledTableCell>

            <StyledTableCell className={classes.mainClass} align={actualAlign}>
                <b>{actualName}</b>
            </StyledTableCell>

            <StyledTableCell className={classes.mainClass} align={budgetAlign}>
                <b>{budgetName}</b>
            </StyledTableCell>

            <StyledTableCell className={classes.mainClass} align={varianceAlign}>
                <b>{varianceName}</b>
            </StyledTableCell>

            <StyledTableCell className={classes.mainClass} align={kpiAlign}>
                <b>{kpIsName}</b>
            </StyledTableCell>

            <StyledTableCell className={classes.mainClass} align={actualPYAlign}>
                <b>{actualPYName}</b>
            </StyledTableCell>

            <StyledTableCell className={classes.mainClass} align={varLYAlign}>
                <b>{varLYName}</b>
            </StyledTableCell>
        </TableRow>
    );
};

export default DashboardHeaderRow;
